import { DirectiveOptions } from 'vue'
import store from '@/store'

export const permission: DirectiveOptions = {
    inserted(el, binding) {
        const { value } = binding
        const roles = store.getters.privileges
        if (Array.isArray(value)) {
            const permissionRoles = value
            const hasPermission = roles.some(role => {
                return permissionRoles.includes(role)
            })
            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`need roles! Like v-permission="['admin','editor']"`)
        }
    }
}
